// extracted by mini-css-extract-plugin
export default {"GalleryContainer":"GalleryHome_GalleryContainer__qjkgM","img3":"GalleryHome_img3__+VFoJ"};